/**
 * WHEN DID THE USER LAST TOUCH THE CONSOLE — the one fact the gateway needs to expire an idle
 * admin session (services/gateway/src/session-idle.ts). Every request `lib/api.ts` sends carries
 * `x-twoke-idle-ms`, and the gateway extends the session only when that says a user gesture is
 * under a minute old. Polls (the annotator's 15 s live pull, `useSession`) go out with the real
 * idle time, so an open tab left alone reports itself idle and expires on schedule.
 *
 * A GESTURE IS A POINTER, A KEY, A WHEEL OR A TOUCH. Not focus, not visibility, not a request:
 * those all happen without anyone at the desk. Passive + capture so nothing in the page can stop
 * the stamp or be slowed by it. SSR-safe: on the server there is no user, and no header is sent.
 */
let last = typeof window === "undefined" ? 0 : Date.now();

if (typeof window !== "undefined") {
  const stamp = () => {
    last = Date.now();
  };
  for (const ev of ["pointerdown", "keydown", "wheel", "touchstart"] as const)
    window.addEventListener(ev, stamp, { passive: true, capture: true });
}

/** Milliseconds since the last user gesture, or `null` on the server. */
export function idleMs(): number | null {
  return typeof window === "undefined" ? null : Math.max(0, Date.now() - last);
}
